<!-- @format -->
<works-form-tag>
    <div class="contents_block skillsheet">
        <table class="detail_table">
            <tr class="detail_table-row">
                <th class="detail_table-heading">
                    タイトル
                    <span class="status_label status_label-required margin-spacing-2_left"></span>
                </th>
                <td class="detail_table-data title">
                    <div class="box_flex02">
                        <div class="box_w50">
                            <input
                                class="text_input"
                                type="text"
                                name="title"
                                id="title"
                                is="binding-tag"
                                errmsg="入力してください"
                                placeholder="サイト名"
                            />
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="detail_table-heading">URL</th>
                <td class="detail_table-data url">
                    <div class="box_flex02">
                        <div class="box_w50">
                            <input
                                class="text_input"
                                type="text"
                                name="url"
                                id="url"
                                is="binding-tag"
                                errmsg="正しいURLを入力してください"
                                placeholder="https://"
                            />
                        </div>
                    </div>
                    <div class="box_flex02"><br></div>
                    <div class="box_flex02">
                        URLを指定した場合、自動的にWEBサイトが指定している画像を取得します
                    </div>
                    <div class="box_flex02">
                        ※WEBページの造りによって取得できない場合があります。その際は、「作品サムネイル画像」を指定してください。
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="detail_table-heading">作品サムネイル画像</th>
                <td class="detail_table-data thumb">
                    <div class="box_flex02">
                        <div
                            class="button button-secondary"
                            onclick="{ uploadImg }"
                            type="button"
                            value="画像をアップロード"
                            data-target=""
                        >
                            画像をアップロード
                        </div>

                        <div
                            style="display:{works.ogpDisplay};"
                            class="button button-secondary button-border margin-spacing-1_left"
                            type="button"
                            onclick="{ogpAction}"
                            value="指定URLから画像を再取得"
                            data-target=""
                        >
                            指定URLから画像を再取得
                        </div>
                    </div>
                    <div class="box_flex02">
                        <div if="{works.thumbnail}">
                            <img class="canvas-size" src="/public-info/works/api/v1/image?file_hash={works.thumbnail}" />
                            <div id="img-del-button"
                                class="button button-border button-secondary-mini"
                                type="button"
                                value="画像を削除する"
                                onclick="{removeImg}"
                                data-target=""
                            >画像を削除する</div>
                        </div>
                        <img-tag onUpload="{ selectedImg }"></img-tag>
                    </div>

                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="detail_table-heading">添付ファイル</th>
                <td class="detail_table-data title">
                    <input type="file" accept='image/*' style="display: none;">
                    <div class="box_flex02">
                        <div
                            class="button button-secondary"
                            type="button"
                            onclick="{ uploadPdf }"
                            value="PDFをアップロード"
                            data-target=""
                        >
                            <i class="com-icon icon-upload"></i>
                            <span>PDFをアップロード</span>
                        </div>
                    </div>
                    <div class="box_flex02">
                        <p class="form_object_warning" style="margin-top: 0.5rem">
                            ※10MB未満のPDFファイルに限ります
                        </p>
                    </div>
                    <div class="box_flex02">
                        <div if="{works.work_file}">
                            <div id="pdf-del-button"
                                class="button button-border button-secondary-mini"
                                type="button"
                                value="添付ファイルを削除する"
                                onclick="{removePdf}"
                                data-target=""
                            >添付ファイルを削除する</div>{works.work_file}
                        </div>
                        <pdf-tag onUpload="{ selectedPdf }"></pdf-tag>
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="detail_table-heading">担当分野<span class="status_label status_label-required margin-spacing-2_left"></span></th>
                <td class="detail_table-data title">
                    <ul class="checkbox_list margin-spacing-1_top" each={ rows in works.masters }>
                        <li class="checkbox_list-item" each={ field in rows }>
                            <input
                                type="checkbox"
                                class="checkbox-input media-publication"
                                name="fields_{field.id}"
                                id="in_charge_fields-{field.id}"
                                is="binding-tag"
                                val="{field.id}"
                            />
                            <label for="in_charge_fields-{field.id}" class="checkbox-parts">{field.label}</label>
                        </li>
                    </ul>

                    <ul class="checkbox_list margin-spacing-1_top">
                        <li class="checkbox_list-item">
                            <input
                                type="checkbox"
                                class="checkbox-input media-publication"
                                name="fields_{works.otherId}"
                                id="fields_{works.otherId}"
                                is="binding-tag"
                                val="{works.otherId}"
                            />
                            <label for="fields_{works.otherId}" class="checkbox-parts">その他</label>
                        </li>
                    </ul>
                    <div class="box_flex02">
                        <div class="box_w50">
                            <input
                                class="text_input"
                                type="text"
                                name="other"
                                id="other"
                                is="binding-tag"
                                errmsg="その他を選択した場合は、必須項目です"
                                placeholder="入力してください"
                                readonly="{works.otherReadonly}"
                            />
                        </div>
                    </div>
                    <div class="error {works.fieldsAlert ? '':'def-hidden'}">担当分野を選択してください</div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="detail_table-heading">
                    コメント
                    <span class="status_label status_label-required margin-spacing-2_left"></span>
                </th>
                <td class="detail_table-data comment">
                    <div class="box_flex02">
                        <div class="box_w70">
                            <textarea
                                class="textarea_input"
                                placeholder="コメント"
                                name="comment"
                                id="comment"
                                is="binding-tag"
                                errmsg="必須項目です"
                                required="required"
                            ></textarea>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="detail_table-heading">限定公開<span class="status_label status_label-required margin-spacing-2_left"></span></th>
                <td class="detail_table-data title">
                    <input
                        type="checkbox"
                        class="checkbox-input media-publication"
                        name="limited_publish_level"
                        id="limited_publish_level"
                        is="binding-tag"
                        val="1"
                    />
                    <label for="limited_publish_level" class="checkbox-parts">「限定公開」にする場合はチェック！
                    </label>
                </td>
            </tr>
        </table>
        <!--/.detail_table-->


        <div class="box_flex03">
            <div
                class="button button-secondary-large button-border"
                onclick="{ list }"
                type="button"
                value="制作実績に戻る"
                data-target=""
            >
                制作実績に戻る
            </div>
            <div
                class="button button-secondary-large margin-spacing-1_left"
                onclick="{ submit }"
                type="button"
                value="{(works.id != null)? '編集':'登録'}する"
                data-target=""
            >{(works.id != null)? '編集':'登録'}する</div>
        </div>
    </div>
    <script>
        import di         from "dependency-injection";
        import works      from "@model/works/api";
        import bindingTag from "@tags/parts/public-info/works/binding.riot";
        import imgTag     from "@tags/parts/public-info/works/image.riot";
        import pdfTag     from "@tags/parts/public-info/works/pdf.riot";

        export default {
            components: {
                'binding-tag': bindingTag,
                'img-tag': imgTag,
                'pdf-tag': pdfTag
            },
            works: works,
            submit(e) {
                e.preventDefault()
                this.works.trigger('register')
            },
            list(e) {
                e.preventDefault()
                this.works.page = 'list'
                this.works.trigger('clear-img')
                this.works.trigger('clear-pdf')
                this.works.trigger('update')
            },
            ogpAction(e) {
                e.preventDefault()
                this.works.ogp_action = 'update'
                this.works.thumb_action = 'delete'
                this.works.thumbnail = ''
                this.works.trigger('preview-ogp')
                this.update()
            },
            uploadImg(e) {
                e.preventDefault()
                this.works.trigger('upload-img')
            },
            uploadPdf(e) {
                e.preventDefault()
                this.works.trigger('upload-pdf')
            },
            removeImg(e) {
                e.preventDefault()
                this.works.thumbnail = ''
                this.works.thumb_action = 'delete'
                this.works.ogp_action = 'delete'
                this.update()
            },
            removePdf(e) {
                e.preventDefault()
                this.works.work_file = ''
                this.works.work_action = 'delete'
                this.update()
            },

            selectedImg(file) {
                this.works.thumbFile = file
            },
            selectedPdf(file) {
                this.works.workFile = file
            },
            listenerPreviewImg() {
                this.works.thumbnail = ''
                this.works.thumb_action = 'update'
                this.works.ogp_action = 'delete'
                this.update()
            },
            listenerPreviewPdf() {
                this.works.work_file = ''
                this.works.work_action = 'update'
                this.update()
            },
            onMounted(props, state) {
                this.works.on('preview-img', this.listenerPreviewImg)
                this.works.on('preview-pdf', this.listenerPreviewPdf)
            },
            onUnmounted(props, state) {
                this.works.off('preview-img', this.listenerPreviewImg)
                this.works.off('preview-pdf', this.listenerPreviewPdf)
            }
        }
    </script>
    <style>
        .canvas-size {
            max-width: 500px;
            margin-top: 12px;
        }
        .def-hidden {
            display: none;
        }
    </style>
</works-form-tag>